import { makeAutoObservable } from 'mobx';
import { NotificationsStore } from '../NotificationsStore';
import { ModuleDetails, ModuleOverview } from 'types/module';
import ModulesService from '../../services/Modules/ModulesService';
import { getErrorMessage } from 'utilities/ErrorHelper';

export class ModulesStore {
  private modulesService: ModulesService;
  private ns: NotificationsStore;

  constructor(modulesService: ModulesService, notificationStore: NotificationsStore) {
    makeAutoObservable(this);
    this.modulesService = modulesService;
    this.ns = notificationStore;
  }

  modules: ModuleOverview[] = [];
  moduleDetails?: ModuleDetails;
  isLoading: boolean = false;

  getModules = async () => {
    try {
      this.isLoading = true;
      const response = await this.modulesService.getModules();
      this.modules = response;

    } catch (ex) {
      this.ns.addToast('error', getErrorMessage(ex), 'error');
    }
    this.isLoading = false;
  };

  getModuleDetails = async (id: string) => {
    try {
      this.isLoading = true;
      this.moduleDetails = await this.modulesService.getModuleDetails(id);
    } catch (ex) {
      this.ns.addToast('error', getErrorMessage(ex), 'error');
    } finally {
      this.isLoading = false;
      console.log(this.moduleDetails);
    }
  };
}

export default ModulesStore;